// extracted by mini-css-extract-plugin
export var bottomRightDock = "_21-0";